import { useQuery } from "@tanstack/react-query";

import { settingsApi } from "api/settingsApi";

// Per-tenant "Dokumenty 2.0" switch, edited on the Settings page.
const DOCUMENTS_V2_ENABLED_SETTING = "documents-v2-enabled";

export const useDocumentsV2Enabled = () => {
  // Same query as the Settings page, so both share one cache entry.
  const { data, isLoading } = useQuery({
    queryKey: ["settings-list"],
    queryFn: () => settingsApi.getSettingsList(),
  });
  // The Sidebar mounts this hook on every page, so a body that is not a list (a mocked or failing API) must read as
  // "off" instead of throwing.
  const rows = Array.isArray(data?.data) ? data.data : [];
  const value = rows.find((s) => s.name === DOCUMENTS_V2_ENABLED_SETTING)?.value ?? "";

  // Off while the settings load and when the row is missing (an API without it). Case-insensitive: a C#
  // bool.ToString() would store "True".
  return { enabled: value.trim().toLowerCase() === "true", isLoading };
};
